/* global Function */

const comparator_org = (v1, v2) => v1 === v2;

function ProxyObserver(opt_options) {
  const options = opt_options || {};

  if (!(typeof options.private === "boolean")) {
    options.private = false;
  }

  let proxy_data = options.data;
  const self = this;
  const comparator = options.opt_comparator || comparator_org; //komperator porównania, bazowy to ===

  if (options.observer) {//tworzymy tylko jak jest podana klasa obserwera, w przeciwnym wypadku VUE sam doda, czego niechcemy :)
    self.__ob__ = new options.observer({});
  }
  self.notify = () => { //możemy ręcznie wymusić powiadomienie VUE
    if (self.__ob__ && Object.prototype.hasOwnProperty.call(self, '__ob__') && self.__ob__ instanceof options.observer) {
      self.__ob__.dep.notify();
    }
  };
  self.toString = () => '' + proxy_data;

  let properties = [];
  function configureFunctions(object) {
    //console.log(object, object.isPrototypeOf(Object));
    if (!object.isPrototypeOf(Object)) {
      //z pominięciem klasy *Object*
      const descriptors = Object.getOwnPropertyDescriptors(object);

      for (let name in descriptors) {
        if (properties.includes(name))
          continue; //zabezpieczenie
        const descriptor = descriptors[name];
        if (name === 'constructor' || !(descriptor.value instanceof Function)) {
          //wszystkie metody z pominięciem konstruktora
          continue;
        }

        self[name] = function () {
          return proxy_data[name]/*.bind(proxy_data)*/.apply(proxy_data, arguments);
        };
        properties.push(name);
      }

      configureFunctions(object.__proto__);//przechodzimy hierarchicznie w górę
    }
  }
  function configureProperties(object) {
    const descriptors = Object.getOwnPropertyDescriptors(object);
    for (let name in descriptors) {
      if (properties.includes(name))
        continue; //zabezpieczenie
      const descriptor = descriptors[name];

      if (!(descriptor.value instanceof Function)) {
        if (!options.private && name.endsWith('_')) {
          //specjalna konfiguracja aby wartości private też brać pod uwagę
          continue;
        }

        Object.defineProperty(self, name, {
          get() {
            return proxy_data[name];
          },
          set(value) {
            proxy_data[name] = value;
          },
          configurable: true,
          enumerable: true
        });
        properties.push(name);
      }
    }
  }
  function configure(object) {
    for (let i in properties) {
      delete this[properties[i]];
    }
    properties = [];

    if (object != null) {
      configureProperties(object);
      configureFunctions(object);
    }
  }

  Object.defineProperty(self, "__value", {
    get() {
      return proxy_data;
    },
    set(data) {
      if (comparator(proxy_data, data))
        return;
      proxy_data = data;
      configure(data);
      self.notify();
    },
    configurable: false,
    enumerable: false
  });
  configure(proxy_data);
}


export {
ProxyObserver
        };



// WEBPACK FOOTER //
// ./src/utils/ProxyObserver.js